<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col md="4">
          <!-- :errMsg="$errors('reqParams', 'source_table', requiredRule)" -->
          <mrc_ess_prompt
            :label="$t('公司')"
            :disabled="true"
            obj="unit"
            v-model="params.company_uuid"
          >
          </mrc_ess_prompt>
        </v-col>
        <v-col md="4">
          <mrc_ess_prompt
            :label="$t('部门')"
            :disabled="true"
            obj="unit"
            v-model="params.department_uuid"
          >
          </mrc_ess_prompt>
        </v-col>
        <v-col md="4">
          <mrc_ess_datePicker
            label="报销日期"
            :disabled="false"
            v-model="params.reimbursement_datetime"
            placeholder="报销日期"
          ></mrc_ess_datePicker>
        </v-col>
        <v-col md="6">
          <mrc_ess_prompt
            :label="$t('姓名')"
            :disabled="true"
            view_fields="show_name"
            value_field="uuid"
            :select_arr="nameArr"
            v-model="params.staff_uuid"
          >
          </mrc_ess_prompt>
        </v-col>
        <v-col md="6">
          <mrc_ess_datePicker
            label="费用产生日期"
            :disabled="false"
            v-model="params.costs_produce_datetime"
            placeholder="费用产生日期"
          ></mrc_ess_datePicker>
        </v-col>
        <v-col md="12">
          <v-btn @click="flag = true">新建</v-btn>
          <mrc_ess_table
            :headers="headers"
            hideAddBtn
            :paginationOptions="paginationOptions"
            :items="desserts"
            :slotKey="['actions']"
          >
            <template v-slot:item.actions="{ item }">
              <span @click="del(item)">删除</span>
            </template>
          </mrc_ess_table>
        </v-col>
        <v-col md="6">
          <mrc_ess_input
            placeholder="合计"
            readonly
            label="合计"
            v-model="total_amount"
          ></mrc_ess_input>
        </v-col>
        <v-col md="6">
          <mrc_ess_input
            placeholder="大写金额"
            readonly
            label="大写金额"
            v-model="params.amount_words"
          ></mrc_ess_input>
        </v-col>

        <v-col md="12">
          <mrc_ess_input
            placeholder="附件"
            label="附件"
            v-model="params.accessory_uuid"
          ></mrc_ess_input>
        </v-col>
        <v-col md="12">
          <mrc_ess_input
            textarea
            placeholder="备注"
            label="备注"
            v-model="params.remark"
          ></mrc_ess_input>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      :loading="loading"
      @success="add"
      @cancel="cancel"
    ></mrc_ess_submitBtn>
    <mrc_ess_myDialog
      title="新建"
      @success="dialogSuccess"
      @cancel="dialogCancel"
      v-model="flag"
    >
      <v-card-text>
        <mrc_ess_input
          textarea
          placeholder="摘要"
          label="摘要"
          v-model="dialogData.summary"
        ></mrc_ess_input>
        <mrc_ess_input
          placeholder="金额"
          label="金额"
          v-model="dialogData.money"
        ></mrc_ess_input>
        <mrc_ess_input
          placeholder="数量"
          label="数量"
          v-model="dialogData.count"
        ></mrc_ess_input>
      </v-card-text>
    </mrc_ess_myDialog>
  </v-card>
</template>

<script>
import {
  getTestclaim_expenseListAdd,
  moneyWords,
} from "@/service/api/data-access-strategy"
import { getBusinessList } from "@/service/api/prompt"
export default {
  props: {},
  data() {
    return {
      flag: false,
      nameArr: [],
      desserts: [],
      loading: false,
      dialogData: {
        summary: "",
        money: "",
        count: "",
      },
      params: {
        department_uuid: this.$store.state.userData.dept_uuid,
        company_uuid: this.$store.state.userData.org_level_uuid,
        staff_uuid: "",
        reimbursement_datetime: new Date().valueOf(),
        costs_produce_datetime: new Date().valueOf(),
        mrbase_sys_expense_claim_sub: [],
        total_amount: "",
        // 大写
        amount_words: "",
        remark: "",
        accessory_uuid: "",
      },
    }
  },
  async created() {
    try {
      const res = await getBusinessList({
        prompt_name: "userId_show_name",
        user_id: this.$store.state.userData.user_id,
      })
      if (res.code == 200) {
        this.nameArr = res.data
        this.params.staff_uuid = this.nameArr[0].uuid
      } else {
        this.$Message({ text: "员工姓名未获取到，请刷新页面重新获取" })
      }
    } catch (err) {
      this.$Message({ text: "员工姓名未获取到，请刷新页面重新获取" })
    }
  },
  mounted() {},
  watch: {
    flag(val) {
      if (val) {
        this.dialogData = {
          summary: "",
          money: "",
          count: "",
        }
      }
    },
  },
  computed: {
    total_amount() {
      let count = 0
      this.desserts.forEach((item) => {
        count += Number(item.money)
      })
      moneyWords({ money: count.toFixed(2) })
        .then((res) => {
          this.params.amount_words = res.data.token
        })
        .catch((err) => {
          console.log(err)
        })
      return count
    },
    paginationOptions() {
      return {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: this.desserts.length, //总条数
        totalpage: 1, //总页数
      }
    },
    headers() {
      return [
        {
          text: this.$t("摘要"),
          align: "start",
          sortable: false,
          value: "summary",
        },
        {
          text: this.$t("金额"),
          align: "start",
          sortable: false,
          value: "money",
        },
        {
          text: this.$t("单据数量"),
          align: "start",
          sortable: false,
          value: "count",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
        },
      ]
    },
  },
  methods: {
    del(item) {
      const index = this.desserts.indexOf(item)
      this.desserts.splice(index, 1)
    },
    async add() {
      this.loading = true
      try {
        this.$set(this.params, "mrbase_sys_expense_claim_sub", this.desserts)
        this.params.total_amount = this.total_amount
        // this.params.reimbursement_datetime = new Date(
        //   this.params.reimbursement_datetime
        // ).valueOf()
        // this.params.costs_produce_datetime = new Date(
        //   this.params.costs_produce_datetime
        // ).valueOf()
        this.params.reimbursement_datetime = this.$moment(
          this.params.reimbursement_datetime
        )
        this.params.costs_produce_datetime = this.$moment(
          this.params.costs_produce_datetime
        )

        const res = await getTestclaim_expenseListAdd(this.params)
        if (res.code == 200) {
          this.$Message({ text: $t("message_added_successfully") })
          this.$router.go(-1)
        }
        this.loading = false
      } catch (err) {
        console.log(err)
        this.loading = false
      }
    },
    cancel() {},
    dialogSuccess() {
      this.flag = false
      this.desserts.push(this.dialogData)
    },
    dialogCancel() {},
  },
}
</script>

<style scoped></style>
